import React from 'react';
import { Navigator } from './Navigator';
import './css/root.scss';

export const Root: React.VFC = () => <Navigator />;
